import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getReferenceVideoAsset, getPlayingAssets } from 'selectors'
import { selectIsTimelinePlaying } from 'selectors/playback'
import { getFPSByRefVideo } from 'Util'
import { PLAYER_TYPE } from 'enums'
import { setPreviewLoading } from 'actions/preview'
import { selectPreviewMode } from 'selectors/preview'
import { useAction } from 'hooks/utils'
import { PREVIEW_MODE } from 'config/constants/preview'
import { usePreviewCommon } from './usePreviewCommon'

export const useTimelinePreviewContainer = () => {
  const playing = useSelector(selectIsTimelinePlaying)
  const refVideo = useSelector(getReferenceVideoAsset)
  const playingAssets = useSelector(getPlayingAssets)
  const activePreviewMode = useSelector(selectPreviewMode)
  const stopPreviewLoading = useAction(setPreviewLoading, false)

  const {
    handleStopRecording,
    togglePlaying,
    mediaRecordingInProgress,
    mediaRecordingInCapture,
    onSelect,
  } = usePreviewCommon({ playing, playerType: PLAYER_TYPE.TIMELINE })
  const showVideoPlayer = Boolean(playingAssets[0]) || Boolean(playingAssets?.length > 0)

  useEffect(() => {
    if (activePreviewMode === PREVIEW_MODE.TIMELINE) {
      stopPreviewLoading()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ activePreviewMode ])

  const timelinePreviewProps = useMemo(() => ({
    isMedia: false,
    srcVideo: playingAssets[0]?.url,
    playing,
    onPlayPause: (mediaRecordingInProgress && !mediaRecordingInCapture) ? handleStopRecording : togglePlaying,
    asset: playingAssets[0],
    fps: getFPSByRefVideo(refVideo),
    showVideoPlayer,
    showThumbnail: false,
    previewPlayerType: PLAYER_TYPE.TIMELINE,
  }), [
    showVideoPlayer,
    playingAssets,
    refVideo,
    playing,
    mediaRecordingInProgress,
    mediaRecordingInCapture,
    handleStopRecording,
    togglePlaying,
  ])

  return {
    timelinePreviewProps,
    onSelect,
  }
}
